import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";

export const ContainerSS = styled(RouterLink)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px 32px;
  margin-bottom: 8px;

  font-size: 13px;
  font-style: normal;
  text-decoration: none;
  line-height: 24px; /* 160% */

  border-radius: 8px;
  cursor: pointer;
  background-color: var(--section-snow-background-color,var(--snow));
  color: var(--link-ebony-color,var(--ebony));

  &:hover {
      box-shadow: ${props =>
        props.theme.name === "dark"
          ? "0px 6px 44px #01001A"
          : "0px 10px 20px rgba(75, 97, 128, 0.08)"};
    }
  }
`;

export const OrderStatusSS = styled.span`
  display: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--section-ebony-light-color, var(--ebony-light));
  text-align: left;
  flex-grow: 1;

  @media (min-width: 48rem) {
    display: inline-block;
    max-width: 10rem;
  }
`;

export const OrderIdSS = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  flex-grow: 1;

  ${ContainerSS}:hover & {
    color: var(--link-color-primary-600-color, var(--color-primary-600));
  }

  @media (min-width: 48rem) {
    font-size: 15px;
  }
`;

export const OrderPeriodSS = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--section-ebony-light-color, var(--ebony-light));
  text-align: left;
  flex-grow: 1;

  @media (min-width: 32rem) {
    min-width: 12rem;
    max-width: 32rem;
    margin-left: auto;
    flex-grow: 2;
  }
  @media (min-width: 48rem) {
    flex-grow: 1;
  }
`;

export const OrderTotalSS = styled.span`
  display: flex;
  font-size: 15px;
  font-weight: 700;

  @media (min-width: 48rem) {
    min-width: 183px;
  }
`;

export const OrderTotalLabelSS = styled.span`
  display: none;
  color: var(--section-granite-color, var(--granite));
  font-size: 13px;
  font-weight: 600;
  margin-right: 32px;

  @media (min-width: 32rem) {
    display: inline-block;
  }
`;

export const ViewLinkSS = styled(RouterLink)`
  max-width: 4rem;
  text-align: right;
  margin-left: auto;
  flex-grow: 1;
  text-decoration: none;
  font-weight: 600;
`;
